export const OtherMenu1 = () => {
  return (
    <span>
      <svg
        className="base"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.3">
          <path
            d="M9.30644 3.43812C10.0798 0.728309 13.9201 0.728309 14.6935 3.43812C15.1083 4.89174 16.6017 5.75397 18.068 5.38642C20.8014 4.70125 22.7216 8.02708 20.7615 10.0517C19.7101 11.1378 19.7101 12.8622 20.7615 13.9483C22.7216 15.973 20.8014 19.2988 18.068 18.6136C16.6017 18.2461 15.1083 19.1083 14.6935 20.5619C13.9201 23.2717 10.0798 23.2717 9.30644 20.5619C8.89159 19.1083 7.39817 18.2461 5.93188 18.6136C3.19844 19.2988 1.27828 15.973 3.23837 13.9483C4.28982 12.8622 4.28982 11.1378 3.23837 10.0517C1.27828 8.02708 3.19844 4.70125 5.93188 5.38642C7.39817 5.75397 8.89159 4.89174 9.30644 3.43812Z"
            stroke="#1A1A1A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.99994 12C8.99994 13.6569 10.3431 15 11.9999 15C13.6568 15 14.9999 13.6569 14.9999 12C14.9999 10.3432 13.6568 9.00001 11.9999 9.00001C10.3431 9.00001 8.99994 10.3432 8.99994 12Z"
            stroke="#1A1A1A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>

      <svg
        className="active-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.82883 3.77272C9.73932 0.549069 14.2607 0.549068 15.1712 3.77272C15.4533 4.77152 16.4688 5.36396 17.4659 5.11142C20.6841 4.29633 22.9448 8.2528 20.6371 10.6614C19.9221 11.4076 19.9221 12.5925 20.6371 13.3388C22.9448 15.7473 20.6841 19.7038 17.4659 18.8887C16.4688 18.6361 15.4533 19.2286 15.1712 20.2274C14.2607 23.451 9.73932 23.451 8.82883 20.2274C8.54673 19.2286 7.53118 18.6361 6.53407 18.8887C3.31589 19.7038 1.05521 15.7473 3.3629 13.3388C4.07791 12.5925 4.07791 11.4076 3.3629 10.6614C1.05521 8.2528 3.31589 4.29633 6.53407 5.11142C7.53118 5.36396 8.54673 4.77152 8.82883 3.77272ZM12.0001 8.48118C10.0767 8.48118 8.51751 10.0566 8.51751 12.0001C8.51751 13.9435 10.0767 15.5189 12.0001 15.5189C13.9234 15.5189 15.4826 13.9435 15.4826 12.0001C15.4826 10.0566 13.9234 8.48118 12.0001 8.48118Z"
          fill="white"
        />
      </svg>
    </span>
  );
};
